import moment from 'moment'
import PropTypes from 'prop-types'
import { useMemo } from 'react'
import { useSelector } from 'react-redux'
import { Translate } from 'react-redux-i18n'
import { Element } from '../../../../../../../common/html/element'
import { PERIOD_TYPE } from '../../../../../constant'
import { selectTypePeriod } from '../../../../../store/slice'
import '../../../../lang/i18n'
import { selectChartHistoricalChange } from '../../../../store/slice'
import BoxInfo from './BoxInfo'
import { mapViewBy } from './constants'
import FilterTime from './FilterTime'
import { HistoricalChangeChart } from './HistoricalChangeChart'
import HistoricalChangeTable from './HistoricalChangeTable'

const CorporateRiskScoreContent = ({
  isDynamicReport,
  settingDynamic = {},
  viewBy,
  filterTime,
  setFilterTime,
}) => {
  const {
    checked: arrValueDynamic = [],
    timeFrequency: timeFrequencyDynamicHistoricalChange,
    timeFrequencyScore: timeFrequencyDynamicBoxInfo,
  } = isDynamicReport ? settingDynamic : {}
  const handleFilterTimeChange = (newFilter) => setFilterTime(newFilter)
  const chartHistoricalChange = useSelector(selectChartHistoricalChange)
  const timeFrequencyStore = useSelector(selectTypePeriod)
  const timeFrequency = isDynamicReport
    ? timeFrequencyDynamicHistoricalChange
    : timeFrequencyStore

  const getTitleFilter = useMemo(() => {
    if (!chartHistoricalChange?.length) return ''

    const firstItem = chartHistoricalChange[0]
    const lastItem = chartHistoricalChange[chartHistoricalChange.length - 1]

    switch (timeFrequency) {
      case PERIOD_TYPE.YEARLY:
        return ` (${firstItem.intYear} - ${lastItem.intYear})`

      case PERIOD_TYPE.QUARTERLY:
        return ` (Q${firstItem.intQuarter}-${firstItem.intYear} - Q${lastItem.intQuarter}-${lastItem.intYear})`

      default: // Monthly
        const formatDate = (item) =>
          moment(`${item.intMonth}/${item.intYear}`, 'MM/YYYY').format(
            'MMM-YYYY',
          )
        return ` (${formatDate(firstItem)} - ${formatDate(lastItem)})`
    }
  }, [chartHistoricalChange, timeFrequency])

  const renderSection = (showScore, showHistorical, isDynamic) => (
    <div style={isDynamic ? null : { padding: 12, display: 'flex' }}>
      {showScore && (
        <div
          className={isDynamic ? 'w100' : 'w30'}
          id="BOX_DATA_CORPORATE_RISK_SCORE"
        >
          <BoxInfo
            timeFrequency={
              isDynamicReport ? timeFrequencyDynamicBoxInfo : timeFrequencyStore
            }
          />
        </div>
      )}
      {showHistorical && (
        <div
          className={isDynamic ? 'w100' : 'w70'}
          style={isDynamic ? { marginTop: 12 } : { marginLeft: 36 }}
          id="CHART_HISTORICAL_CHANGE"
        >
          <div className="dFlex justifyContentBetween">
            <Element
              style={{ color: '#191D25', lineHeight: '16px', fontWeight: 600 }}
            >
              <Translate value="corporateRiskScore.historicalChange" />
              {isDynamicReport && getTitleFilter}
            </Element>
            {!isDynamicReport && (
              <FilterTime
                filterTime={filterTime}
                onFilterTimeChange={handleFilterTimeChange}
              />
            )}
          </div>
          {viewBy === mapViewBy.chart.value ? (
            <HistoricalChangeChart
              isDynamicReport={isDynamicReport}
              settingDynamic={settingDynamic}
              timeFrequency={timeFrequency}
            />
          ) : (
            <HistoricalChangeTable
              isDynamicReport={isDynamicReport}
              settingDynamic={settingDynamic}
              timeFrequency={timeFrequency}
            />
          )}
        </div>
      )}
    </div>
  )

  if (isDynamicReport) {
    const showScore = arrValueDynamic.includes('score')
    const showHistorical = arrValueDynamic.includes('historicalChange')

    if (showScore && !showHistorical) return renderSection(true, false, true)
    if (!showScore && showHistorical) return renderSection(false, true, true)
    return renderSection(true, true, true)
  }

  return renderSection(true, true, false)
}

CorporateRiskScoreContent.propTypes = {
  filterTime: PropTypes.object,
  viewBy: PropTypes.string,
  isDynamicReport: PropTypes.bool,
  settingDynamic: PropTypes.object,
}

export default CorporateRiskScoreContent
